export default __webpack_public_path__ + "static/Build-Query-646d4f8d77cacb6689cc430f7f371bef.png";